import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import queryString from 'query-string';
import { connect } from 'react-redux';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import PropTypes from 'prop-types';
import { get, getJson } from 'session';
import Drawer from '@material-ui/core/Drawer';
import { Acl } from 'modules/common/components/Acl';
import Pagination from 'modules/common/components/Pagination';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import * as actions from '../actions';
import * as c from '../constants';
import history from '../../../../history';
import ExportHistoryModal from '../modals/ExportHistoryModal';

const styles = () => ({
  dialogPaper: {
    width: '100%',
    maxWidth: '400px',
  },
});

const EwalletServicesReport = ({
  getEwalletReportList,
  eWalletReportList,
  isLoading,
  pager,
  classes,
}) => {
  const [showSide, setShowSide] = useState(false);

  const authProfile = getJson('profile') || {};
  const [token, setToken] = useState('');

  const handleDownload = id => {
    const path = `${
      process.env.REACT_APP_WS
    }api/v1/administrators/report_file_exports_download/${id}?bearer_token=${token}
    &email=${_.get(authProfile, 'email')}`;
    return `${path}`;
  };

  useEffect(() => {
    const getToken = get('token') || '';
    setToken(getToken);
  }, []);

  const permissions = getJson('permissions');
  // const [downloadUrl, setUrl] = useState('');
  const [formData, setFormData] = useState({
    date_from: `${moment(new Date())
      .subtract(30, 'days')
      .format('MM-DD-YYYY')}`,
    date_to: `${moment(new Date()).format('MM-DD-YYYY')}`,
    mobile_number: '',
    type: 'WALLET_BREAKDOWN',
  });
  // const token = get('token') || '';
  // const authProfile = getJson('profile') || {};
  const syncFilters = params => {
    return history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(params),
    });
  };

  const handleDateChange = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleChangePage = page => {
    const args = {
      ...formData,
      date_from: `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
      page,
      type: 'WALLET_BREAKDOWN',
    };
    getEwalletReportList(args);
    syncFilters(args);
  };

  useEffect(() => {
    getEwalletReportList({
      date_from: `${moment(new Date())
        .subtract(30, 'days')
        .format('YYYY-MM-DD')}`,
      date_to: `${moment(new Date()).format('YYYY-MM-DD')}`,
      type: 'WALLET_BREAKDOWN',
    });
    // queryString.parse(window.location.search)
  }, []);

  const onSearch = e => {
    e.preventDefault();
    let args = {};
    if (
      _.get(formData, 'date_from') === '' ||
      _.get(formData, 'date_to') === ''
    ) {
      args = {
        ...formData,
      };
    }
    if (
      _.get(formData, 'date_from') !== '' ||
      _.get(formData, 'date_to') !== ''
    ) {
      args = {
        ...formData,
        date_from: `${moment(_.get(formData, 'date_from')).format(
          'YYYY-MM-DD'
        )}`,
        date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
      };
    }
    getEwalletReportList(args);
  };

  const handleExportHistory = () => e => {
    e.preventDefault();
    setShowSide(!showSide);
  };

  const handleClose = () => {
    setShowSide(false);
  };

  return (
    <>
      <div className="dashboard-card">
        <div className="row mt-2">
          <div className="col-12 d-flex">
            <div className="row-nav font-weight-bold text-black">
              Generated History
            </div>
          </div>
        </div>
        <form onSubmit={onSearch} className="mb-5">
          <div className="d-flex">
            <div className="form-input-group">
              <label className="label-reports font-weight-bold">
                Export Date From
              </label>
              <DateInputPicker
                className="full-input"
                onChange={handleDateChange('date_from')}
                value={_.get(formData, 'date_from') || ''}
              />
            </div>

            <div className="form-input-group ml-2">
              <label className="label-reports font-weight-bold">
                Export Date To
              </label>
              <DateInputPicker
                className="full-input"
                onChange={handleDateChange('date_to')}
                value={_.get(formData, 'date_to') || ''}
              />
            </div>
            <div className="form-input-group ml-2">
              <div className="full-input">
                <button
                  disabled={
                    _.isEmpty(_.get(formData, 'date_from')) ||
                    _.isEmpty(_.get(formData, 'date_to'))
                  }
                  type="submit"
                  className="btn btn-primary cms-bg-color-primary text-white button-ewallet-filter"
                >
                  <i className="fas fa-search" /> &nbsp;&nbsp;Search
                </button>
              </div>
            </div>
            <div className="form-input-group ml-auto">
              <div className="full-input">
                <button
                  onClick={handleExportHistory()}
                  className="btn btn-primary cms-bg-color-primary font-weight-bold button-ewallet-filter"
                  type="button"
                >
                  <i className="fas fa-download mr-2" /> Export
                </button>
              </div>
            </div>
          </div>
        </form>
        {isLoading ? (
          <div
            className="loading d-flex text-center justify-content-center align-items-center"
            style={{ height: '500px' }}
          >
            <div className="spinner text-center ">
              <span className="fas fa-5x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              // padding: "10px",
              marginBottom: '20px',
            }}
          >
            <div className="mb-3">
              {eWalletReportList.length > 0 ? (
                <div className="mt-2 table-responsive">
                  <table className="table table-striped table-sm table-bordered table-hover">
                    <thead className="table-header">
                      <tr className="billing-table-tr">
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Date Exported
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          File Name
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          File Path
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Size
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Status
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="table-details">
                      {eWalletReportList
                        ?.filter(
                          data =>
                            _.get(data, 'attributes.type') ===
                            'WALLET_BREAKDOWN'
                        )
                        ?.map(item => {
                          return (
                            <tr
                              className="billing-table-tr"
                              key={_.get(item, 'id')}
                            >
                              <td>
                                {_.get(item, 'attributes.date_exported') ||
                                  '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.file_name') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.file_path') || '---'}
                              </td>
                              <td>{_.get(item, 'attributes.size') || '---'}</td>
                              <td>
                                {_.get(item, 'attributes.status') || '---'}
                              </td>
                              {Acl(permissions, [
                                'DOWNLOAD E-WALLET REPORT',
                              ]) && (
                                <td>
                                  <a
                                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2"
                                    href={handleDownload(item.id)}
                                    target="_blank"
                                    without="true"
                                    rel="noopener noreferrer"
                                  >
                                    <i className="fas fa-folder-open mr-2" />{' '}
                                    Download
                                  </a>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <div className="text-center mx-auto py-4">
                    <img
                      src={emptyStateImage}
                      className="img-responsive image-wrapper mb-4 mt-3"
                      alt="Empty State"
                    />
                    <p className="emp-title mb-0">No Item Found</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <div className="list-pagination">
          {pager.total_pages > 1 && (
            <div className="d-flex justify-content-center text-center align-item-center">
              <Pagination data={pager} onChange={handleChangePage} />
            </div>
          )}
        </div>
      </div>
      <Drawer
        PaperProps={{ classes: { root: classes.dialogPaper } }}
        anchor="right"
        open={showSide}
        onClose={handleClose}
      >
        <ExportHistoryModal handleClose={handleClose} />
      </Drawer>
    </>
  );
};
EwalletServicesReport.propTypes = {
  getEwalletReportList: PropTypes.instanceOf(Function).isRequired,
  eWalletReportList: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
};
const mapStateToProps = ({ api }) => ({
  eWalletReportList: _.get(api, `${c.E_WALLET_REPORT_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.E_WALLET_REPORT_LIST) > -1,
  pager: _.get(api, `${c.E_WALLET_REPORT_LIST}.pager`) || {},
});
const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);
export default withStyles(styles)(enhance(EwalletServicesReport));
